import { useState } from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '@/lib/auth';
import { AUTH } from '@/constants/testIds';
import { toast } from 'sonner';

export const LoginPage = () => {
  const { login } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await login(email, password);
      toast.success('SESSION_INITIATED');
      const dest = loc.state?.from || '/pro/manage';
      nav(dest);
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Login failed');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="max-w-md mx-auto mt-16 px-6">
      <div className="text-[10px] tracking-[0.4em] uppercase text-[#38BDF8] mb-3">
        // AUTH_PROMPT
      </div>
      <h1 className="text-3xl font-bold uppercase tracking-tighter mb-8">
        Initiate Session<span className="caelix-caret"></span>
      </h1>
      <form data-testid={AUTH.loginForm} onSubmit={submit} className="c-card space-y-4">
        <div>
          <label className="c-label" htmlFor="login-email">Operator Email</label>
          <input
            id="login-email"
            data-testid={AUTH.loginEmail}
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="operator@caelix.io"
            className="c-input"
          />
        </div>
        <div>
          <label className="c-label" htmlFor="login-password">Passphrase</label>
          <input
            id="login-password"
            data-testid={AUTH.loginPassword}
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="••••••••"
            className="c-input"
          />
        </div>
        <button
          data-testid={AUTH.loginSubmit}
          type="submit"
          disabled={busy}
          className="c-btn-primary w-full"
        >
          {busy ? 'AUTHENTICATING…' : 'INITIATE_SESSION'}
        </button>
        <div className="text-xs text-gray-500 pt-2 border-t border-[#3F3F46] flex flex-wrap items-center justify-between gap-2">
          <span>
            No account yet?{' '}
            <Link
              data-testid={AUTH.loginGoSignup}
              to="/signup"
              className="text-[#38BDF8] hover:underline uppercase tracking-widest"
            >
              CREATE_OPERATOR
            </Link>
          </span>
          <Link
            data-testid={AUTH.loginForgot}
            to="/forgot-password"
            className="text-gray-500 hover:text-[#38BDF8] uppercase tracking-widest text-[10px]"
          >
            FORGOT_PASSPHRASE?
          </Link>
        </div>
      </form>
    </div>
  );
};

export default LoginPage;
